import { FC } from 'react';
import { useParams } from 'react-router-dom';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuizEvents } from 'store/quizEvent/quizEventSelectors';
// Components
import { Loader, Message } from 'components/Utilities';
import QuizEventListItem from './QuizEventListItem';

const QuizEventsList:FC = () => {
  const { t } = useTranslation();
  const { quizId } = useParams<{ quizId: string }>();

  const quizEvents = useAppSelector(selectQuizEvents);

  if ( !quizEvents ) return <Loader />;
  if ( !quizEvents.length ) return <Message text={t('pages.quizEvents.noData')} />;
  return (
    <table className="responsive-table">
      <thead>
        <tr>
          <th className="text-left">{t('labels.name')}</th>
          <th className="text-left">{t('labels.type')}</th>
          <th className="text-left">{t('labels.status')}</th>
          <th className="text-left">{t('labels.triggeredBy')}</th>
          <th className="text-right">{t('labels.actions')}</th>
        </tr>
      </thead>
      <tbody>
        {quizEvents.map((quizEvent) => (
          <QuizEventListItem
            key={`quiz-event-item-${quizEvent._id}`}
            quizEvent={quizEvent}
            quizId={quizId}
          />
        ))}
      </tbody>
    </table>
  )
}

export default QuizEventsList;
